import Link from 'next/link'
import cl from 'classnames'
import { ReactNode } from 'react'
import styles from '../styles.module.scss'

interface Props {
  isBlock: boolean
  page: number
  queryParams?: any
  children: ReactNode
}

export const ButtonMovePage: React.FC<Props> = ({
  isBlock,
  children,
  page,
  queryParams
}) => {
  return isBlock ? (
    <Link
      href={{
        query: { page: page, ...queryParams }
      }}
      className={styles.buttonMovePage}
    >
      {children}
    </Link>
  ) : (
    <a className={cl(styles.buttonMovePage, styles.disabledButtonMovePage)}>
      {children}
    </a>
  )
}
